import React from 'react';
import { COLORS, Color } from '../../../styles/variables';

interface RoadsterSelectedIconProps {
  color?: Color;
}

const RoadsterSelectedIcon: React.FC<RoadsterSelectedIconProps> = ({ color = COLORS.black }) => (
  <svg width="76" height="38" viewBox="0 0 76 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_816_45120)">
      <path
        d="M20.51 18.36L46.8 17.12C46.7211 16.8235 46.6907 16.5162 46.7101 16.21C46.8001 15.36 46.8001 14.76 47.4801 14.76C47.8045 14.7042 48.1378 14.7777 48.4088 14.9645C48.6798 15.1514 48.8669 15.4369 48.9301 15.76C49.0201 16.01 49.0201 16.18 49.1001 16.44C49.1801 16.7 49.27 16.78 49.36 16.78H60.04C63.6189 16.9378 67.1853 17.3084 70.7201 17.89V19.17C71.212 19.6985 71.5568 20.3467 71.7201 21.05V23.87L72.7201 24.3C72.8789 24.5554 72.9653 24.8493 72.9701 25.15C72.8965 26.2435 72.5529 27.3018 71.9701 28.23L68.55 29.6L11.4 29.94L3.40002 29.51L3.82007 23.96C3.89758 23.4437 4.09185 22.952 4.38818 22.5222C4.68452 22.0924 5.07507 21.736 5.53003 21.48C6.64003 20.71 8.78008 20.2 11.0801 19.6C14.1585 18.6453 17.3421 18.071 20.5601 17.89L20.51 18.36Z"
        fill={color}
        stroke={color}
        strokeWidth="0.75"
      />
      <path d="M54.32 28.88L25.87 29.06" stroke="white" strokeWidth="0.75" strokeMiterlimit="10" />
      <path
        d="M23.91 26.64C23.9603 27.7899 23.6685 28.929 23.0715 29.9131C22.4745 30.8972 21.5992 31.6822 20.556 32.1688C19.5129 32.6553 18.3489 32.8217 17.2112 32.6468C16.0735 32.4719 15.0133 31.9636 14.1646 31.1861C13.3158 30.4086 12.7166 29.3969 12.4427 28.2789C12.1689 27.1609 12.2327 25.9869 12.6261 24.9051C13.0195 23.8234 13.7249 22.8827 14.653 22.2018C15.581 21.5209 16.6902 21.1305 17.8401 21.08C19.2371 20.9968 20.6123 21.4553 21.6801 22.36"
        fill={color}
      />
      <path
        d="M23.91 26.64C23.9603 27.7899 23.6685 28.929 23.0715 29.9131C22.4745 30.8972 21.5992 31.6822 20.556 32.1688C19.5129 32.6553 18.3489 32.8217 17.2112 32.6468C16.0735 32.4719 15.0133 31.9636 14.1646 31.1861C13.3158 30.4086 12.7166 29.3969 12.4427 28.2789C12.1689 27.1609 12.2327 25.9869 12.6261 24.9051C13.0195 23.8234 13.7249 22.8827 14.653 22.2018C15.581 21.5209 16.6902 21.1305 17.8401 21.08C19.2371 20.9968 20.6123 21.4553 21.6801 22.36"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M67.47 26.64C67.5204 27.7899 67.2286 28.929 66.6315 29.9131C66.0345 30.8972 65.159 31.6822 64.1159 32.1688C63.0728 32.6554 61.9089 32.8217 60.7712 32.6468C59.6335 32.4719 58.5732 31.9636 57.7244 31.1861C56.8757 30.4086 56.2765 29.3969 56.0026 28.279C55.7288 27.161 55.7927 25.9869 56.1861 24.9052C56.5795 23.8234 57.2848 22.8827 58.2128 22.2018C59.1409 21.5209 60.2501 21.1306 61.4 21.08C62.7999 20.9974 64.1782 21.4556 65.25 22.36"
        fill={color}
      />
      <path
        d="M67.47 26.64C67.5204 27.7899 67.2286 28.929 66.6315 29.9131C66.0345 30.8972 65.159 31.6822 64.1159 32.1688C63.0728 32.6554 61.9089 32.8217 60.7712 32.6468C59.6335 32.4719 58.5732 31.9636 57.7244 31.1861C56.8757 30.4086 56.2765 29.3969 56.0026 28.279C55.7288 27.161 55.7927 25.9869 56.1861 24.9052C56.5795 23.8234 57.2848 22.8827 58.2128 22.2018C59.1409 21.5209 60.2501 21.1306 61.4 21.08C62.7999 20.9974 64.1782 21.4556 65.25 22.36"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M5.28006 22.62C5.03006 22.96 5.28006 23.9 5.28006 23.9H8.7001C9.3001 23.9 9.90009 22.02 9.56009 21.77C9.22009 21.52 5.54006 22.28 5.28006 22.62Z"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M72.21 21.21L70.71 21.08L69.86 19.88L71.36 18.79"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M20.5701 17.92C20.5701 17.92 27.2401 13.65 33.7301 12.37"
        stroke={color}
        strokeWidth="0.75"
      />
    </g>
    <defs>
      <clipPath id="clip0_816_45120">
        <rect width="70.39" height="21.08" fill="white" transform="translate(3 12)" />
      </clipPath>
    </defs>
  </svg>
);

export default RoadsterSelectedIcon;
